import * as React from "react";
import { LockOutlined } from "@ant-design/icons";
import { Input, Button, Row, Col, Divider, Form } from "antd";
import { PasswordKeys } from "../../../core/common/Constants";
import { TPasswordChangePresentationModel } from "../../presenter/model/PasswordChangePresentationModel";
import Text from "antd/lib/typography/Text";
const PasswordChangeForm = ({
  password,
  translate,
  setPasswordValue,
  disableButton,
  changePassword,
  validationErrors,
  loading,
  onClickBackButton,
  setPassword
}: {
  password: TPasswordChangePresentationModel;
  translate: any;
  setPasswordValue: (key: string, value: string) => void;
  disableButton: boolean;
  changePassword: any;
  validationErrors: any;
  loading: boolean;
  onClickBackButton: any;
  setPassword?: boolean;
}) => {
  const oldPasswordErrors = validationErrors[PasswordKeys.OLD_PASSWORD];
  const newPasswordErrors = validationErrors[PasswordKeys.NEW_PASSWORD];
  const confirmPasswordErrors =
    validationErrors[PasswordKeys.CONFIRM_NEW_PASSWORD];
  return (
    <div className="login-container">
      <div className="login-form-container">
        <Form layout={"vertical"}>
          <div className="app-title" style={{ marginBottom: 20 }}>
            {translate("settings.password.title")}
          </div>
          {setPassword && (
            <div>
              <Text>{translate("settings.password.password_expired")}</Text>
            </div>
          )}
          <Row
            gutter={8}
            className={!setPassword ? "content-section-emphasize" : undefined}
          >
            {!setPassword && (
              <Col sm={24}>
                <Form.Item
                  label={translate("settings.password.old_password")}
                  validateStatus={oldPasswordErrors ? "error" : "success"}
                  help={
                    translate(`settings.password.${oldPasswordErrors}`) ||
                    undefined
                  }
                >
                  <Input.Password
                    prefix={<LockOutlined className={"input-icon"} />}
                    placeholder={translate("settings.password.old_password")}
                    value={password.oldPassword}
                    onChange={(e) =>
                      setPasswordValue(
                        PasswordKeys.OLD_PASSWORD,
                        e.target.value
                      )
                    }
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
            )}
            <Col sm={24}>
              <Form.Item
                label={translate("settings.password.new_password")}
                validateStatus={newPasswordErrors ? "error" : "success"}
                help={
                  translate(
                    `settings.password.${
                      newPasswordErrors?.length > 1
                        ? newPasswordErrors[0]
                        : newPasswordErrors
                    }`
                  ) || undefined
                }
              >
                <Input.Password
                  prefix={<LockOutlined className={"input-icon"} />}
                  placeholder={translate("settings.password.new_password")}
                  value={password.newPassword}
                  onChange={(e) =>
                    setPasswordValue(PasswordKeys.NEW_PASSWORD, e.target.value)
                  }
                  allowClear={true}
                />
              </Form.Item>
            </Col>
            <Col sm={24}>
              <Form.Item
                label={translate("settings.password.new_password_confirmation")}
                validateStatus={confirmPasswordErrors ? "error" : "success"}
                help={
                  translate(
                    `settings.password.${
                      confirmPasswordErrors && confirmPasswordErrors.length > 1
                        ? confirmPasswordErrors[0]
                        : confirmPasswordErrors
                    }`
                  ) || undefined
                }
              >
                <Input.Password
                  prefix={<LockOutlined className={"input-icon"} />}
                  placeholder={translate(
                    "settings.password.confirm_new_password"
                  )}
                  value={password.confirmNewPassword}
                  onChange={(e) =>
                    setPasswordValue(
                      PasswordKeys.CONFIRM_NEW_PASSWORD,
                      e.target.value
                    )
                  }
                  allowClear={true}
                />
              </Form.Item>
            </Col>
          </Row>
          {!setPassword && (
            <Divider type={"horizontal"} className={"separator"} />
          )}
          <Row className={"content-section-buttons"}>
            <Col sm={24} className={"content-section-buttons"}>
              {!setPassword && (
                <Button
                  type={"link"}
                  onClick={onClickBackButton}
                  className={"button-link"}
                >
                  {translate("settings.password.go_back")}
                </Button>
              )}
              <Button
                type="primary"
                disabled={disableButton}
                onClick={changePassword}
                loading={loading}
                className={setPassword ? "login-button" : undefined}
              >
                {translate("settings.password.change")}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default PasswordChangeForm;
